import { render, staticRenderFns } from "./UploadStatus.vue?vue&type=template&id=514e7472&scoped=true&"
import script from "./UploadStatus.vue?vue&type=script&lang=ts&"
export * from "./UploadStatus.vue?vue&type=script&lang=ts&"
import style0 from "./UploadStatus.vue?vue&type=style&index=0&id=514e7472&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "514e7472",
  null
  
)

export default component.exports